/*
 * @Author: Tina Huang
 * @Date: 2024-03-28 16:06:39
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-03-03 17:54:11
 * @Description:
 */
// import type { Dayjs } from 'dayjs'
import locale from 'antd/es/date-picker/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import { Calendar, Card, Space, Image, CalendarProps, Badge, BadgeProps } from 'antd'
import { getVipPicks } from '@/server'
import { useCallback, useEffect, useMemo, useState } from 'react'
import decryptUtils from '@/server/aes'
import dayjs, { Dayjs } from 'dayjs'
import { type } from 'os'

export default function VipBase() {
  const [datasource, setDatasource] = useState<any>([])
  const [activeMonth, setActiveMonth] = useState<Dayjs>(dayjs())
  const getData = () => {
    getVipPicks().then((res) => {
      setDatasource(res)
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const getDateList = (value: Dayjs, type = 'date') => {
    const _f = type === 'month' ? 'YYYY/MM' : 'YYYY/MM/DD'
    const cur = value.format(_f)
    return datasource.filter((item: any) => {
      const _d = dayjs(item?.created_time).format(_f)
      return _d === cur
    })
  }
  const topList = useMemo(() => {
    return datasource.filter((item: any) => item?.properties?.['置顶']?.checkbox)
  }, [datasource])

  const thisMonthList = useMemo(() => {
    return getDateList(activeMonth, 'month')
  }, [datasource, activeMonth])

  const dateCellRender = useCallback(
    (value: Dayjs) => {
      const listData = getDateList(value)
      return (
        <ul className="events" style={{ maxWidth: 140 }}>
          {listData.map((item: any) => (
            <li key={item.id}>
              <Badge
                status="success"
                text={item?.properties?.Name?.title?.[0]?.plain_text}
                className="w-full overflow-hidden whitespace-nowrap text-ellipsis"
              />
            </li>
          ))}
        </ul>
      )
    },
    [datasource]
  )

  const cellRendar: CalendarProps<Dayjs>['cellRender'] = (current, info) => {
    // console.log(current)
    return dateCellRender(current)
    return info.originNode
  }

  const monthChange = (value: Dayjs) => {
    if (value.format('YYYY/MM') !== activeMonth.format('YYYY/MM')) {
      setActiveMonth(value)
    }
  }

  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Welcome to Widverse</h1>
      {/* content */}
      <Space className="mt-4 w-full" align="start">
        <div>
          <Card className="w-90 mb-4" hoverable>
            <div className="font-bold text-xl">❤️ 组件库</div>
          </Card>
          <Card hoverable className="w-90" cover={<Image src={topList?.[0]?.cover?.file?.url} />}>
            {topList?.[0]?.properties?.Name?.title?.[0]?.plain_text} {topList?.[0]?.cover?.file?.url}
          </Card>
        </div>
        <Card className="w-120" title={'📅 更新日历' + `｜该月已更新${thisMonthList.length}篇`} hoverable>
          <Calendar locale={locale} fullscreen={false} cellRender={cellRendar} onChange={monthChange} />
        </Card>
      </Space>
      <Card className="w-full mt-4" title="👑 会员模版"></Card>
    </div>
  )
}
